import React from 'react'
import { Link } from "react-router-dom"
import './Header.css'

const Header = () => {
    return (
        <React.Fragment>
            <header className="bg-image">
                <div className="bg-container">
                    {/* <h1 className="landingHeader1">Awesome Title</h1> */}
                    {/* <h2 className="landingHeader2"> </h2> */}
                    <p> Babble is Solana's premier message board app. Post your thoughts from your wallet, follow other users, and see what they have to say, all on Solana's powerful network. </p>
                    <p> With the entire application being powered and stored on-chain, you'll never have to worry about censorship or data theft. </p>
                    <Link to="/app">Try the beta now!</Link>
                </div>
            </header>
        </React.Fragment>
    )
}
export default Header;
